import React, {Component} from 'react';
import {Input, InputGroup, InputGroupAddon} from 'reactstrap';
import * as attachments from 'catalog/actions/attachments'
import {connect} from 'react-redux';
import autobind from 'autobind-decorator';
import DeleteAttachment from 'catalog/components/DeleteAttachment'

@connect(
    state => (
        {
            auth: state.apa
        }
    )
    ,
    dispatch => {
        return {
            deleteAttachment: (attachment) => {
                dispatch(attachments.remove(attachment));
            }
        }
    }
)
export default class Attachment extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isOpen: false,
            deleted: false,
            attachment: props.attachment
        }
    }

    @autobind
    toggle() {
        this.setState(
            {
                isOpen: !this.state.isOpen
            }
        )
    }

    @autobind
    confirmDelete() {
        this.props.deleteAttachment(this.state.attachment);
        this.toggle();
        this.setState({
            deleted: true
        })
    }

    @autobind
    updateAttachment() {
        throw Error
    }


    render() {
        if (this.state.deleted)
            return null
        const attachment = this.state.attachment;
        return (
            <li>
                <InputGroup>
                    <Input type='text' value={attachment.name} onChange={e => this.setState({
                        attachment: {...this.state.attachment, name: e.target.value}
                    })}
                           onBlur={this.updateAttachment}
                    />
                    <InputGroupAddon addonType='append'>
                        <a className="btn btn-primary" href={attachment.file}>
                            <i className='fa fa-download'> </i>
                        </a>
                    </InputGroupAddon>
                    <InputGroupAddon addonType='append'>
                    </InputGroupAddon>
                    <DeleteAttachment attachment={attachment}/>
                </InputGroup>
            </li>
        )
    }
}
